import React, { createContext, useContext, useState } from 'react';

const DocumentDateContext = createContext();

export const DocumentDateProvider = ({ children }) => {
  const [DocStartDate, DocSetStartDate] = useState(null);
  const [DocEndDate, DocSetEndDate] = useState(null);
  const [DocHasFetched, DocSetHasFetched] = useState(null);

  return (
    <DocumentDateContext.Provider 
      value={{
        DocStartDate, 
        DocSetStartDate, 
        DocEndDate, 
        DocSetEndDate,
        DocHasFetched, 
        DocSetHasFetched,
        }}>
      {children}
    </DocumentDateContext.Provider>
  );
};

export const useDocumentDate = () => {
  const ctx = useContext(DocumentDateContext);
  if (!ctx) {
    return {
      DocStartDate: null,
      DocSetStartDate: () => {},
      DocEndDate: null,
      DocSetEndDate: () => {},
      DocHasFetched: null, 
      DocSetHasFetched: () => {},
    };
  }
  return ctx;
};